import { TruncatedTextTooltip } from "components/common/TruncatedTextTooltip";
import type { ElementGroupRowTitleProps } from "./types";

export const ElementGroupRowTitle = ({
  title,
  subtitle,
  isSelected,
  badge,
  highlightQuery,
}: ElementGroupRowTitleProps) => {
  return (
    <span className="min-w-0 flex flex-col">
      <TruncatedTextTooltip
        text={title}
        highlightQuery={highlightQuery}
        className={
          isSelected
            ? "font-semibold text-blue-700"
            : "font-medium text-gray-900"
        }
      />
      {subtitle && (
        <TruncatedTextTooltip
          text={subtitle}
          className="text-xs text-gray-500 font-normal"
        />
      )}
      {badge && <span className="mt-1">{badge}</span>}
    </span>
  );
};
